import { render } from "./confirmation.vue?vue&type=template&id=0ef4b8f1&scoped=true&ts=true"
import script from "./confirmation.vue?vue&type=script&lang=ts"
export * from "./confirmation.vue?vue&type=script&lang=ts"

import "./confirmation.vue?vue&type=style&index=0&id=0ef4b8f1&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef4b8f1"]])

export default __exports__